import { Component } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

@Component({
  selector: 'theme-button',
  templateUrl: './theme-button.component.html',
  styleUrls: ['./theme-button.component.scss']
})
export class ThemeButtonComponent {
  
  // https://stackblitz.com/edit/angular-material-switch-themes-by-toggle-utgqtb
  // added class="theme-init" to body on index.html
  constructor(private overlay: OverlayContainer) {}
  
  toggleTheme(): void {
    const container = this.overlay.getContainerElement().classList;

    if (container.contains("theme-init")) {
      container.remove("theme-init");
      container.add("theme-alternate");
    } else {
      container.remove("theme-alternate");
      container.add("theme-init");
    }
    
    const body = document.body.classList;
    if (body.contains("theme-init")) {
      body.remove("theme-init");
      body.add("theme-alternate");
    } else {
      body.remove("theme-alternate");
      body.add("theme-init");
    }
  }
  
}